import { Injectable, inject } from '@angular/core';
import { UploadDocumentService } from '../services/upload-document.service';
import { PaginatorNew, TableOrder } from '../../global';
import { InvoiceFillingUpdate } from '../entities/invoice-filling.entity';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentSandbox {
  private readonly uploadService = inject(UploadDocumentService);

  public getDocuments = (page: PaginatorNew, order: TableOrder, searchText: string = '', filters: any = null) =>
    this.uploadService.getDocuments(page, order, searchText, filters);

  public createDocument = (document: InvoiceFillingUpdate) => this.uploadService.createDocument(document);

  public getInvoices = (page: PaginatorNew, order: TableOrder, search: string = '') => this.uploadService.getInvoices(page, order, search);

  public startOcr = (id: number) => this.uploadService.startOcr(id);

  public verifyOcr = (ids: Array<number>) => this.uploadService.verifyOcr(ids);

  public renameDocument = (id: number, name: string) => this.uploadService.renameDocument(id, name);

  public attachInvoices = (invoiceId: number, documentIds: Array<string | number>) => this.uploadService.attachInvoices(invoiceId, documentIds);

  public getDocumentPages = (documentId: number) => this.uploadService.getDocumentPages(documentId);

  public loadDetailedOcr = (ids: Array<number>) => this.uploadService.loadDetailedOcr(ids);
}
